module.exports = __webpack_public_path__ + "img/avatar-4.ce7db0ab.jpg";